export default __webpack_public_path__ + "static/media/E1.b7237a86.svg";